import React, { PureComponent } from "react";
import styles from "./CapacityPlaning.local.scss";
import { MARKS_COLLABORATOR_FILTER } from "Config";

export class FolderStateFilter extends PureComponent {
  render() {
    const { value } = this.props;

    return (
      <div className={styles.folderState}>
        {MARKS_COLLABORATOR_FILTER.map(item => (
          <span
            key={item.value}
            onClick={() =>
              this.props.handleDisplayChangeStatusFolders(item.value, item.type)
            }
            style={{
              borderColor: item.color,
              color: item.value === value ? "white" : "#8d8d8d",
              backgroundColor: item.value === value ? item.color : "#e6e6fa82"
            }}
          >
            <p>{item.label}</p>
          </span>
        ))}
      </div>
    );
  }
}
export default FolderStateFilter;



// WEBPACK FOOTER //
// ./src/components/CapacityPlanning/FolderStateFilter.js